module.exports = __webpack_public_path__ + "static/media/repair-e.a34ec092.svg";